<app-header-nav-widget 
    [text]="('pp_offer_order_title' | translate) + ' - ' + levelSablon.ajanlatcim"
    [description]="levelSablon.levelcim"
    [historyLink]="['/offers']">
</app-header-nav-widget>

@if (levelSablon?.verziok?.length > 1) {

    <div class="flex flex-wrap items-center gap-5 justify-between mt-6">

        <span class="ml-2 text-xs">
            Ajánlati verziók szűkítéséhez használja a jobb oldali szűrőmezőket
        </span>
    
        <div class="flex items-center flex-wrap gap-5">
            <div class="flex items-center gap-2.5">
                <select class="select select-sm w-28">
                    <option value="all">
                        Mind
                    </option>
                    <option value="orderable">
                        Csak aktív
                    </option>
                </select>
                <select class="select select-sm w-56">
                    <option value="kelt.asc">
                        Legrégebbi elöl
                    </option>
                    <option value="kelt.desc">
                        Legújabb elöl
                    </option>
                </select>
            </div>
            <div class="flex">
                <label class="input input-sm">
                    <i class="ki-filled ki-magnifier">
                    </i>
                    <input placeholder="Paraméter keresés" type="text" value="">
                </label>
            </div>
        </div>
    </div>

}

<div class="flex flex-col gap-5 lg:gap-7.5 mt-6">
    <div class="grid grid-cols-1 lg:grid-cols-3 gap-5 lg:gap-7.5">

        <div class="card bg-center bg-cover bg-no-repeat hero-bg">
            <div class="card-body lg:pt-9 lg:pb-7.5">
                <div class="flex flex-wrap md:flex-nowrap items-center gap-6 md:gap-10">
                    <div class="flex flex-col gap-3">
                        <h3 class="text-sm font-semibold text-gray-900">
                            {{ levelSablon.megszolitas }}                            
                        </h3>
                        <span class="font-normal text-primary mt-2 mb-2 text-sm">{{ levelSablon.levelcim }}</span>

                        @for(bekezdes of levelSablon.ajanlatszoveg; track $index) {
                            <p class="text-xs text-gray-700 leading-5.5" [innerHTML]="bekezdes">
                            </p>
                        } 
                        <p class="text-xs text-gray-700 leading-5.5" [innerHTML]="levelSablon.utoszoveg">
                        </p>       
                    </div>
                </div>
            </div>
        </div>

        @for(verzio of levelSablon.verziok; track $index) {
            <!-- verziok -->
            <div class="card">
                <div class="card-header">
                    <span class="card-title">
                        <i class="ki-filled ki-note-2"></i>
                        <span class="text-sm ml-2 font-normal text-gray-800" [innerHTML]="verzio.title"></span>
                    </span>
                </div>
                <div class="card-body lg:pt-9 lg:pb-7.5">

                    @if (scrollParam.get('option_rendeles_nagyszoveg').is(true)) {

                        <div data-accordion="true">
                            <div class="accordion-item active [&:not(:last-child)]:border-b border-b-gray-200">
                                <button class="accordion-toggle py-4 group">
                                    <a class="text-base text-gray-900 font-medium" (click)="onChangeAccordionState(verzio.index, 1)">
                                        Az ajánlat paraméterei
                                    </a>
                                    <i class="ki-outline ki-plus text-gray-600 text-2sm accordion-active:hidden"
                                        [class.block]="verzioAccordions[verzio.index].state != 1"
                                        [class.hidden]="verzioAccordions[verzio.index].state == 1"
                                        >
                                    </i>
                                    <i class="ki-outline ki-minus text-gray-600 text-2sm accordion-active:block"
                                        [class.block]="verzioAccordions[verzio.index].state == 1"
                                        [class.hidden]="verzioAccordions[verzio.index].state != 1"
                                        >
                                    </i>
                                </button>
                                <div class="accordion-content" [class.hidden]="verzioAccordions[verzio.index].state != 1">
                                    <div class="text-gray-700 text-md pb-4">
    
                                        <table class="table align-middle text-gray-700 font-medium text-sm">
                                            <thead>
                                                <tr>
                                                    <th class="min-w-[1/3]">
                                                        Megnevezés
                                                    </th>
                                                    <th>
                                                        Érték
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody class="text-xs">
                    
                                                <!-- adatsorok -->
                                                @for(a of verzio.adatsorok; track $index) {
                                                    <tr>
                                                        <td [innerHTML]="a.cimke">
                                                        </td>
                                                        <td [innerHTML]="a.adat">
                                                        </td>
                                                    </tr>
                                                }
                    
                                                <!-- arak -->
                                                @for(a of verzio.arak; track $index) {
                                                    <tr>
                                                        <td [innerHTML]="a.cimke">
                                                        </td>
                                                        <td [innerHTML]="a.adat">
                                                        </td>
                                                    </tr>
                                                }
                    
                                            </tbody>
                                        </table>
    
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item [&:not(:last-child)]:border-b border-b-gray-200">
                                <button class="accordion-toggle py-4 group">
                                    <span class="text-base text-gray-900 font-medium" (click)="onChangeAccordionState(verzio.index, 2)">
                                        További fontos információk
                                    </span>
                                    <i class="ki-outline ki-plus text-gray-600 text-2sm accordion-active:hidden"
                                        [class.block]="verzioAccordions[verzio.index].state != 2"
                                        [class.hidden]="verzioAccordions[verzio.index].state == 2"
                                        >
                                    </i>
                                    <i class="ki-outline ki-minus text-gray-600 text-2sm accordion-active:block" 
                                        [class.block]="verzioAccordions[verzio.index].state == 2"
                                        [class.hidden]="verzioAccordions[verzio.index].state != 2"
                                        >
                                    </i>
                                </button>
                                <div class="accordion-content" [class.hidden]="verzioAccordions[verzio.index].state != 2">
                                    <div class="text-gray-700 text-md pb-4 scrollable h-[400px]" [innerHTML]="verzio.description">
                                    </div>
                                </div>
                            </div>
                        </div>

                    } @else {

                        <table class="table align-middle text-gray-700 font-medium text-sm">
                            <thead>
                                <tr>
                                    <th class="min-w-[1/3]">
                                        Megnevezés
                                    </th>
                                    <th>
                                        Érték
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="text-xs">
    
                                <!-- adatsorok -->
                                @for(a of verzio.adatsorok; track $index) {
                                    <tr>
                                        <td [innerHTML]="a.cimke">
                                        </td>
                                        <td [innerHTML]="a.adat">
                                        </td>
                                    </tr>
                                }
    
                                <!-- arak -->
                                @for(a of verzio.arak; track $index) {
                                    <tr>
                                        <td [innerHTML]="a.cimke">
                                        </td>
                                        <td [innerHTML]="a.adat">
                                        </td>
                                    </tr>
                                }
    
                            </tbody>
                        </table>

                    }

                </div>
                <div class="card-footer justify-beetwen">
                    @if(verzio.rendelheto) {
                        <span class="text-xs text-gray-500 mr-2">
                            Az ajánlat verzió megrendeléshez kérjük kattintson a megrendelés gombra.
                        </span>
                        <button class="btn btn-primary btn-sm" [routerLink]="['/order', verzio.level, verzio.version]">
                            <i class="ki-filled ki-ki-handcart">
                            </i>
                            Megrendelés
                        </button>
                    } @else {
                        <div class="flex">
                            <i class="ki-filled ki-information-4 text-lg text-danger mr-2"></i>
                            <span class="text-xs text-gray-500">                            
                                Az ajánlat verzió már nem rendelhető, kérjük forduljon nyomdai kapcsolattartójához.
                            </span>
                        </div>
                    }
                </div>
            </div>
            <!-- verziok -->
        }

    </div>
</div>